<template>
  <fou-dropdown-menu
    :isBlur="isBlur"
    :options="options"
    :selected-value="selectedDateRangeDays"
    @fou-dropdown-menu:change="onDropdownChange"
  >
  
    <template #dropdownToggleIcon>
      <span class="calendar-icon" v-if="!isBlur" />
      <span class="calendar-icon-blur" v-if="isBlur"/>
    </template>
    <template #dropdownMenuIcon>
      <span class="tick-icon" />
    </template>
  </fou-dropdown-menu>
</template>

<script src="./script.js"></script>
<style lang="scss" src="./stylesheet/index.scss" />
